import { render, staticRenderFns } from "./Lazy.vue?vue&type=template&id=6a86ac3f"
import script from "./Lazy.vue?vue&type=script&lang=js"
export * from "./Lazy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports